import React from "react";
var css = {
  "topLoader": "rui-Jevto",
  "loading": "rui-X8A8N"
};
var TopLoader = function TopLoader(_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? "fixed" : _ref$position;
  return /*#__PURE__*/React.createElement("div", {
    className: css.topLoader,
    style: {
      position: position
    }
  });
};
export default TopLoader;